import React from "react";
import { QuestionCircleOutlined } from "@ant-design/icons";

const HomeFAQ = () => {
  return (
    <section
      className="py-20 xl:py-24 bg-white bg-center"
      style={{ backgroundImage: "url('/img/pattern-white.svg')" }}
    >
      <div className="container">
        <div className="text-center">
          <span className="inline-block py-px px-2 mb-4 text-xs leading-5 text-blue-500 bg-blue-100 font-medium uppercase rounded-full">
            常见问题
          </span>
          <h2 className="mb-4 text-2xl md:text-3xl !leading-tight text-slate-800 font-bold tracking-tight">
            常见问题解答
          </h2>
          <p className="mb-24 text-base md:text-lg text-slate-500">
            关于AI智能软件服务的常见问题，帮助您更好地了解我们的产品和服务。
          </p>
        </div>
        <div className="flex flex-wrap -mx-4 text-slate-800 gap-y-16">
          <div className="w-full md:w-1/2 lg:w-1/3 px-4">
            <div className="relative h-full p-8 pt-20  bg-slate-100  rounded-md hover:shadow-xl transition duration-200 min-h-60">
              <div className="absolute left-1/2 -ml-6 flex -top-6 h-12 w-12 mb-6 mx-auto items-center justify-center text-white bg-blue-600 rounded-full">
                <QuestionCircleOutlined className="text-xl" />
              </div>
              <h3 className="mb-4 text-lg leading-tight font-medium">
                AI智能软件服务可以嵌入到哪些类型的电子产品中？
              </h3>
              <p className="text-slate-500">
                我们的AI智能软件服务可以嵌入到各种电子产品中，包括智能家电、智能穿戴设备、智能家居控制系统、智能汽车等。
              </p>
            </div>
          </div>
          <div className="w-full md:w-1/2 lg:w-1/3 px-4">
            <div className="relative h-full p-8 pt-20  bg-slate-100  rounded-md hover:shadow-xl transition duration-200 min-h-60">
              <div className="absolute left-1/2 -ml-6 flex -top-6 h-12 w-12 mb-6 mx-auto items-center justify-center text-white bg-blue-600 rounded-full">
                <QuestionCircleOutlined className="text-xl" />
              </div>
              <h3 className="mb-4 text-lg leading-tight font-medium">
                嵌入AI智能软件服务需要多长时间？
              </h3>
              <p className="text-slate-500">
                集成时间取决于产品的复杂性和开发团队的经验，一般来说，简单产品可以在1-2周内完成集成，复杂产品可能需要1-2个月。
              </p>
            </div>
          </div>
          <div className="w-full md:w-1/2 lg:w-1/3 px-4">
            <div className="relative h-full p-8 pt-20  bg-slate-100  rounded-md hover:shadow-xl transition duration-200 min-h-60">
              <div className="absolute left-1/2 -ml-6 flex -top-6 h-12 w-12 mb-6 mx-auto items-center justify-center text-white bg-blue-600 rounded-full">
                <QuestionCircleOutlined className="text-xl" />
              </div>
              <h3 className="mb-4 text-lg leading-tight font-medium">
                AI智能软件服务的费用如何计算？
              </h3>
              <p className="text-slate-500">
                我们提供灵活的收费模式，包括一次性授权费、按设备数量收费、按使用量收费等，具体费用根据您的需求和规模而定。
              </p>
            </div>
          </div>
          <div className="w-full md:w-1/2 lg:w-1/3 px-4">
            <div className="relative h-full p-8 pt-20  bg-slate-100  rounded-md hover:shadow-xl transition duration-200 min-h-60">
              <div className="absolute left-1/2 -ml-6 flex -top-6 h-12 w-12 mb-6 mx-auto items-center justify-center text-white bg-blue-600 rounded-full">
                <QuestionCircleOutlined className="text-xl" />
              </div>
              <h3 className="mb-4 text-lg leading-tight font-medium">
                AI智能软件服务支持哪些语言？
              </h3>
              <p className="text-slate-500">
                我们的AI智能软件服务支持多种语言，包括中文、英文、日语、韩语等，您可以根据产品需求选择合适的语言。
              </p>
            </div>
          </div>

          <div className="w-full md:w-1/2 lg:w-1/3 px-4">
            <div className="relative h-full p-8 pt-20  bg-slate-100  rounded-md hover:shadow-xl transition duration-200 min-h-60">
              <div className="absolute left-1/2 -ml-6 flex -top-6 h-12 w-12 mb-6 mx-auto items-center justify-center text-white bg-blue-600 rounded-full">
                <QuestionCircleOutlined className="text-xl" />
              </div>
              <h3 className="mb-4 text-lg leading-tight font-medium">
                如何保证AI智能软件服务的稳定性和安全性？
              </h3>
              <p className="text-slate-500">
                我们采用了多层次的安全防护机制，包括数据加密、访问控制、定期安全审计等，确保AI服务的稳定性和安全性。
              </p>
            </div>
          </div>
          <div className="w-full md:w-1/2 lg:w-1/3 px-4">
            <div className="relative h-full p-8 pt-20  bg-slate-100  rounded-md hover:shadow-xl transition duration-200 min-h-60">
              <div className="absolute left-1/2 -ml-6 flex -top-6 h-12 w-12 mb-6 mx-auto items-center justify-center text-white bg-blue-600 rounded-full">
                <QuestionCircleOutlined className="text-xl" />
              </div>
              <h3 className="mb-4 text-lg leading-tight font-medium">
                提供哪些技术支持和服务？
              </h3>
              <p className="text-slate-500">
                我们提供全面的技术支持和服务，包括SDK集成指导、开发文档、API支持、在线培训、7x24小时技术支持等。
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HomeFAQ;
